module.exports = __webpack_public_path__ + "img/chadgpt-logo.8f5baac0.svg";